import { DateTime } from 'luxon'

export class Statistic {
  constructor(
    private timestamp: DateTime,
    private maxT: number,
    private max1hourVol: number,
    private max1dayVol: number,
    private areaT5Plus: number,
  ) {}

  getTimestamp(): DateTime {
    return this.timestamp
  }

  getMaxT(): number {
    return this.maxT
  }

  getMax1hourVol(): number {
    return this.max1hourVol
  }

  getMax1dayVol(): number {
    return this.max1dayVol
  }

  getAreaT5Plus(): number {
    return this.areaT5Plus
  }
}
